module.exports = __webpack_public_path__ + "img/goods16-7.b43b9a84.jpg";